/**
 * @author zz85 / https://github.com/zz85
 *
 * Based on 'A Practical Analytic Model for Daylight'
 * aka The Preetham Model, the de facto standard analytic skydome model
 * http://www.cs.utah.edu/~shirley/papers/sunsky/sunsky.pdf
 *
 * First implemented by Simon Wallner
 * http://www.simonwallner.at/projects/atmospheric-scattering
 *
 * Improved by Martin Upitis
 * http://blenderartists.org/forum/showthread.php?245954-preethams-sky-impementation-HDR
 *
 * Three.js integration by zz85 http://twitter.com/blurspline
 */
module.exports = function (THREE) {
  var Sky = function () {

    var shader = Sky.SkyShader;

    var material = new THREE.ShaderMaterial( {
      fragmentShader: window.eqc.sky.fragment,
      vertexShader: window.eqc.sky.vertex,
      uniforms: THREE.UniformsUtils.clone( shader.uniforms ),
      side: THREE.BackSide
    } );

    // THREE.Mesh.call( this, new THREE.SphereGeometry( 450000, 32, 15 ), material );
    THREE.Mesh.call( this, new THREE.SphereGeometry( 450000, 32, 15 ), new THREE.MeshStandardMaterial({ color: 0xffffff }) );

  };

  Sky.prototype = Object.create( THREE.Mesh.prototype );

  Sky.SkyShader = {
    uniforms: {
      luminance: {type: 'f', value: 1.0},
      turbidity: {type: 'f', value: 2.0},
      rayleigh: {type: 'f', value: 1.0},
      mieCoefficient: {type: 'f', value: 0.005},
      mieDirectionalG: {type: 'f', value: 0.8},
      sunPosition: {type: 'v3', value: new THREE.Vector3(0, -700000, 0)},
      cameraPos: {type: 'v3', value: new THREE.Vector3(100000.0, -40000.0, 0.0)},
      refractiveIndex: {type: 'f', value: 1.0003},
      numMolecules: {type: 'f', value: 2.542e25},
      depolarizationFactor: {type: 'f', value: 0.035},
      primaries: {type: 'v3', value: new THREE.Vector3(6.8e-7, 5.5e-7, 4.5e-7)},
      mieKCoefficient: {type: 'v3', value: new THREE.Vector3(0.686, 0.678, 0.666)},
      mieV: {type: 'f', value: 4.0},
      rayleighZenithLength: {type: 'f', value: 8.4e3},
      mieZenithLength: {type: 'f', value: 1.25e3},
      sunIntensityFactor: {type: 'f', value: 1000.0},
      sunIntensityFalloffSteepness: {type: 'f', value: 1.5},
      sunAngularDiameterDegrees: {type: 'f', value: 0.0093333},
      tonemapWeighting: {type: 'f', value: 9.50}
    }
  };

  return Sky;
}



//////////////////
// WEBPACK FOOTER
// ./static/static-assets/eqc/three/Sky.js
// module id = 5TLl
// module chunks = 0